import { CHECKBOX, getNameByBit } from "../../modules/checkbox_constants"
import { getMenuItems } from "../CheckboxMenus"
import { getMax } from "../../pages/companiesHouse/pageFunctions/checkboxFunctions"

// Creates and returns an object {url, checkboxes} containing the current url and checkbox settings
const checkboxSettingsForCsv = props => {
  // console.log('CheckboxSettingsForCsv props:', props)

  const { checkboxes, kind, tabIndex } = props
  const checkboxSettings = ["Checkboxes:"]
  var checkboxNames

  // Get the checkbox items that make up the menu for this tab
  var items = getMenuItems({ kind, tabIndex })

  items
    .filter(item => item.hooks) // Ignore 'view' and dividers
    .forEach(item => {
      // allChecked = item.hooks.every(hook => checkboxes[hook] === getMax(hook))

      const { hooks, text: { text: checkboxGroupHeader }, } = item
      const hook = hooks[0]

      // If the group has only one checkbox. Eg HOOK.CONNECTIONS: "conns"
      // Exclude the group if not checked
      if (hooks.length === 1 && getMax(hook) === 1) {
        checkboxNames = getCheckboxNames({ checkboxes, hook })

        if (checkboxNames)
          checkboxSettings.push(`${checkboxGroupHeader}: ${checkboxNames}`)

        //Else, if all the checkboxes are checked append '*name of group*: All selected`
      } else if (hooks.every(hook => checkboxes[hook] === getMax(hook)))
        checkboxSettings.push(`${checkboxGroupHeader}: All selected`)

      //Else, append the selected items in each checkbox group
      else {
        checkboxNames = ""
        hooks.forEach(hook => checkboxNames += getCheckboxNames({ checkboxes, hook }))
        checkboxSettings.push(`${checkboxGroupHeader}: ${checkboxNames}`)
      }
    })

  return checkboxSettings
}

// Gets the names of the selected checkboxes for the given hook and returns as string
// Eg 'FTSE 100, FTSE 250, Other LSE'
const getCheckboxNames = ({ checkboxes, hook }) => {
  var names = ""
  const bits = listSetBits(checkboxes[hook])

  bits.forEach(bit => {
    var name = getNameByBit(CHECKBOX[hook], bit)
    names += name + ', '
  })

  // Return result having removed final ', '
  return names.slice(0, -2)
}

// Get an array of all the bits that are set
// eg Indexes 'FTSE 100', 'FTSE 250' and 'Other LSE' checked would return [1, 2, 16]
const listSetBits = checkboxes => {
  const bits = []
  let mask = 1
  while (mask <= checkboxes) {
    if (checkboxes & mask)
      bits.push(mask)

    mask <<= 1
  }
  return bits
}

export default checkboxSettingsForCsv